"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M15 27a12 12 0 0 1 9.529-11.743A11.557 11.557 0 0 0 25.388 11c0-5.547-2.942-8.647-7.387-8.647s-7.47 3.222-7.47 8.647a11.874 11.874 0 0 0 2.8 7.329 1.539 1.539 0 0 1 .392.993v2.214a1.528 1.528 0 0 1-1.333 1.542c-8.931.777-10.326 6.886-10.326 9.3 0 .268.031 1.321.051 1.585h15.122A11.933 11.933 0 0 1 15 27z" }),
  React.createElement("path", { d: "M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9zm5 9.4a.5.5 0 0 1-.5.5H28v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V28h-3.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H26v-3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V26h3.5a.5.5 0 0 1 .5.5z" })
);

